module.exports = __webpack_public_path__ + "img/photo-7.8b92d9b5.jpg";